import { render, staticRenderFns } from "./checkingList.vue?vue&type=template&id=b855d50e&scoped=true"
import script from "./checkingList.vue?vue&type=script&lang=js"
export * from "./checkingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b855d50e",
  null
  
)

export default component.exports